var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showField()
    ? _c("div", { class: _vm.getClasses(), on: { click: _vm.activateField } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showLabel,
                expression: "showLabel"
              }
            ],
            staticClass: "field-label"
          },
          [_vm._v(_vm._s(_vm.customField.label))]
        ),
        _vm._v(" "),
        _vm.customField.field_type == "requisition_number"
          ? _c("div", { staticClass: "text-field-wrap" }, [
              _c("div", { staticClass: "text-field" }, [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.editing,
                        expression: "!editing"
                      }
                    ],
                    staticClass: "exclude-outside-click edit-d-title"
                  },
                  [_vm._v("#" + _vm._s(_vm.customField.value))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editing,
                        expression: "editing"
                      },
                      {
                        name: "click-outside",
                        rawName: "v-click-outside",
                        value: _vm.outside,
                        expression: "outside"
                      }
                    ],
                    staticClass: "input-group"
                  },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.customField.value,
                          expression: "customField.value"
                        }
                      ],
                      ref: "customInput",
                      staticClass: "form-control",
                      attrs: { placeholder: _vm.customField.label },
                      domProps: { value: _vm.customField.value },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          _vm.editing = false
                        },
                        change: function($event) {
                          return _vm.updateCustomField(_vm.customField)
                        },
                        blur: function($event) {
                          _vm.editing = false
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.customField,
                            "value",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.customField.field_type == "currency"
          ? _c("div", { staticClass: "text-field-wrap" }, [
              _c("div", { staticClass: "currency-field" }, [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.editing,
                        expression: "!editing"
                      }
                    ],
                    staticClass: "exclude-outside-click edit-d-title"
                  },
                  [
                    _vm._v(
                      "$" +
                        _vm._s(
                          _vm.customField.value
                            ? _vm.formatPrice(_vm.customField.value)
                            : "0.00"
                        )
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editing,
                        expression: "editing"
                      },
                      {
                        name: "click-outside",
                        rawName: "v-click-outside",
                        value: _vm.outside,
                        expression: "outside"
                      }
                    ],
                    staticClass: "input-group"
                  },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.customField.value,
                          expression: "customField.value"
                        }
                      ],
                      ref: "customInput",
                      staticClass: "form-control",
                      attrs: { placeholder: _vm.customField.label },
                      domProps: { value: _vm.customField.value },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          _vm.editing = false
                        },
                        change: function($event) {
                          return _vm.updateCustomField(_vm.customField)
                        },
                        blur: function($event) {
                          _vm.editing = false
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.customField,
                            "value",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.customField.field_type == "text"
          ? _c("div", { staticClass: "text-field-wrap" }, [
              _c("div", { staticClass: "text-field" }, [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.editing,
                        expression: "!editing"
                      }
                    ],
                    staticClass: "exclude-outside-click edit-d-title"
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.customField.value ? _vm.customField.value : "N/A"
                      )
                    )
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.editing,
                      expression: "editing"
                    },
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.outside,
                      expression: "outside"
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.customField.value,
                      expression: "customField.value"
                    }
                  ],
                  ref: "customInput",
                  staticClass: "form-control",
                  attrs: { placeholder: _vm.customField.label, type: "text" },
                  domProps: { value: _vm.customField.value },
                  on: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      _vm.editing = false
                    },
                    blur: function($event) {
                      _vm.editing = false
                    },
                    change: function($event) {
                      return _vm.updateCustomField(_vm.customField)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.customField, "value", $event.target.value)
                    }
                  }
                })
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.customField.field_type == "wysiwyg"
          ? _c(
              "div",
              { staticClass: "field-wrap" },
              [
                _c("ckeditor", {
                  ref: "customInput",
                  attrs: {
                    editorUrl: "/js/ckeditor/ckeditor.js",
                    id: "custom-field",
                    config: _vm.editorConfig
                  },
                  on: {
                    input: function($event) {
                      _vm.changed = true
                    },
                    blur: function($event) {
                      return _vm.checkChangedFieldValue(_vm.customField)
                    },
                    ready: function($event) {
                      _vm.changed = false
                    }
                  },
                  model: {
                    value: _vm.customField.value,
                    callback: function($$v) {
                      _vm.$set(_vm.customField, "value", $$v)
                    },
                    expression: "customField.value"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.customField.field_name == "engagement_manager"
          ? _c(
              "div",
              {
                staticClass: "field-wrap coordinator-field",
                on: { click: _vm.showEngagementManager }
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "info-bubbles cursor-pointer exclude-outside-click"
                  },
                  [
                    _vm.engagementManager
                      ? [
                          _vm.engagementManager.id
                            ? _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover.html",
                                      modifiers: { hover: true, html: true }
                                    }
                                  ],
                                  staticClass:
                                    "initials badge badge-primary exclude-outside-click project-coordinator",
                                  attrs: { title: _vm.engagementManager.name }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("textInitials")(
                                        _vm.engagementManager.name
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      : [
                          _c(
                            "span",
                            { staticClass: "initials  exclude-outside-click" },
                            [_vm._v("None")]
                          )
                        ],
                    _vm._v(" "),
                    _c("plus-button", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.editing,
                          expression: "!editing"
                        }
                      ],
                      staticClass: "tagged-tags"
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "custom-field" },
                  [
                    _c("multiselect", {
                      directives: [
                        {
                          name: "click-outside",
                          rawName: "v-click-outside",
                          value: _vm.outside,
                          expression: "outside"
                        },
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.editing,
                          expression: "editing"
                        }
                      ],
                      ref: "engagementManagerRef",
                      attrs: {
                        label: "name",
                        "track-by": "id",
                        "option-height": 42,
                        options: _vm.allActiveUsers,
                        "show-labels": false,
                        multiple: false,
                        "allow-empty": false,
                        searchable: true
                      },
                      on: {
                        close: function($event) {
                          _vm.editing = false
                        },
                        input: function($event) {
                          return _vm.changeEngagementManager()
                        }
                      },
                      model: {
                        value: _vm.engagementManager,
                        callback: function($$v) {
                          _vm.engagementManager = $$v
                        },
                        expression: "engagementManager"
                      }
                    })
                  ],
                  1
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.customField.field_name == "project_lead"
          ? _c(
              "div",
              {
                staticClass: "field-wrap coordinator-field",
                on: { click: _vm.showProjectLead }
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "info-bubbles cursor-pointer exclude-outside-click"
                  },
                  [
                    _vm.projectLead
                      ? [
                          _vm.projectLead.id
                            ? _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover.html",
                                      modifiers: { hover: true, html: true }
                                    }
                                  ],
                                  staticClass:
                                    "initials badge badge-primary exclude-outside-click project-coordinator",
                                  attrs: { title: _vm.projectLead.name }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("textInitials")(
                                        _vm.projectLead.name
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      : [_c("span", [_vm._v("None")])],
                    _vm._v(" "),
                    _c("plus-button", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.editing,
                          expression: "!editing"
                        }
                      ],
                      staticClass: "tagged-tags"
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "custom-field" },
                  [
                    _c("multiselect", {
                      directives: [
                        {
                          name: "click-outside",
                          rawName: "v-click-outside",
                          value: _vm.outside,
                          expression: "outside"
                        },
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.editing,
                          expression: "editing"
                        }
                      ],
                      ref: "projectLeadRef",
                      attrs: {
                        label: "name",
                        "track-by": "id",
                        "option-height": 42,
                        options: _vm.allActiveUsers,
                        "show-labels": false,
                        multiple: false,
                        "allow-empty": false,
                        searchable: true
                      },
                      on: {
                        close: function($event) {
                          _vm.editing = false
                        },
                        input: function($event) {
                          return _vm.changeProjectLead()
                        }
                      },
                      model: {
                        value: _vm.projectLead,
                        callback: function($$v) {
                          _vm.projectLead = $$v
                        },
                        expression: "projectLead"
                      }
                    })
                  ],
                  1
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.customField.field_type == "color_picker"
          ? _c("div", { staticClass: "color-picker-field-wrap" }, [
              _c(
                "div",
                { staticClass: "text-field" },
                [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.editing,
                          expression: "!editing"
                        }
                      ],
                      staticClass: "exclude-outside-click",
                      staticStyle: { "border-radius": "10px" },
                      style: {
                        background: _vm.customField.value
                          ? _vm.customField.value
                          : "transparent",
                        color: _vm.customField.value
                          ? "var(--wf-secondary)"
                          : "var(--wf-primary)",
                        padding: _vm.customField.value ? "5px 10px" : "5px 0"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.customField.value ? _vm.customField.value : "N/A"
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("twitter-picker", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editing,
                        expression: "editing"
                      },
                      {
                        name: "click-outside",
                        rawName: "v-click-outside",
                        value: _vm.outside,
                        expression: "outside"
                      }
                    ],
                    on: { input: _vm.updateColor },
                    model: {
                      value: _vm.color,
                      callback: function($$v) {
                        _vm.color = $$v
                      },
                      expression: "color"
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.customField.field_type == "status"
          ? _c("div", { staticClass: "field-wrap no-icon" }, [
              _vm.customField.value
                ? _c(
                    "span",
                    {
                      staticClass:
                        "exclude-outside-click field-value status-field-value",
                      style: {
                        backgroundColor:
                          _vm.parseValue(_vm.customField.value).color ||
                          _vm.customField.value.color
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.parseValue(_vm.customField.value).name ||
                            _vm.customField.value.name
                        )
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.customField.value
                ? _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.editing,
                          expression: "!editing"
                        }
                      ],
                      staticClass: "exclude-outside-click field-value"
                    },
                    [_vm._v("Click to set...")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "custom-field status-field" },
                [
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editing,
                        expression: "editing"
                      }
                    ],
                    staticClass: "custom-field-outside-bg-mobile"
                  }),
                  _vm._v(" "),
                  _c("multiselect", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editing,
                        expression: "editing"
                      },
                      {
                        name: "field-dismiss",
                        rawName: "v-field-dismiss",
                        value: _vm.outside,
                        expression: "outside"
                      }
                    ],
                    ref: "customInput",
                    attrs: {
                      searchable: false,
                      options: _vm.getOptions,
                      "custom-label": _vm.customLabel,
                      "show-labels": false
                    },
                    on: {
                      close: function($event) {
                        _vm.editing = false
                      },
                      input: function($event) {
                        return _vm.updateCustomField(_vm.customField)
                      },
                      select: function($event) {
                        _vm.editing = false
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "option",
                          fn: function(props) {
                            return [
                              _c(
                                "div",
                                {
                                  style: {
                                    color: "var(--wf-secondary)",
                                    borderRadius: "10px",
                                    backgroundColor: props.option.color,
                                    height: "40px",
                                    lineHeight: "40px",
                                    textAlign: "center"
                                  }
                                },
                                [_vm._v(_vm._s(props.option.name))]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2413709391
                    ),
                    model: {
                      value: _vm.customField.value,
                      callback: function($$v) {
                        _vm.$set(_vm.customField, "value", $$v)
                      },
                      expression: "customField.value"
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.customField.field_type == "textarea"
          ? _c("div", { staticClass: "field-wrap" }, [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.editing,
                      expression: "!editing"
                    },
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      modifiers: { hover: true }
                    }
                  ],
                  staticClass:
                    "exclude-outside-click field-value text-hover-bg",
                  attrs: { title: _vm.customField.value }
                },
                [_vm._v(_vm._s(_vm.customField.value || "Click to set..."))]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "custom-field" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.editing,
                      expression: "editing"
                    },
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.outside,
                      expression: "outside"
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.customField.value,
                      expression: "customField.value"
                    }
                  ],
                  ref: "customInput",
                  staticClass: "form-control custom-inputs",
                  attrs: { rows: _vm.rows },
                  domProps: { value: _vm.customField.value },
                  on: {
                    change: function($event) {
                      return _vm.updateCustomField(_vm.customField)
                    },
                    blur: function($event) {
                      _vm.editing = false
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.customField, "value", $event.target.value)
                    }
                  }
                })
              ])
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("#")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("$")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }